import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons';

export const CheckIcon = () => (
    <div className="check-icon">
        <FontAwesomeIcon icon={faCheck} />
    </div>
)
export default CheckIcon;




// WEBPACK FOOTER //
// ./src/components/icons/CheckIcon.js